import React from 'react'
import Header from '../../../../Components/Header'
import Createwarehouse from './Createwarehouse'
import { Helmet } from 'react-helmet'

function CreateWarehouseMaster() {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Warehouse - Create</title>
			</Helmet>
            <Header/>
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <Createwarehouse/>
            </div>
             </div>


  )
}

export default CreateWarehouseMaster
